/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscriptions.js                                                                */
/**********************************************************************************************************************/
/* subscriptions */
HafasWebapp.prototype.subscriptions = {};


HafasWebapp.prototype.subscriptions.app = function (_me) {
  // switch Application Context
  Hafas.ps.sub('/app/switchContext', Hafas.bind(_me.Controller.App.switchContext, _me));

  // switch Language
  Hafas.ps.sub('/app/switchLanguage', Hafas.bind(_me.Controller.App.switchLanguage, _me));

  // resize ResultContainer if necessary
  Hafas.ps.sub('/app/events/resize', Hafas.bind(_me.Controller.GUI.resize, _me));
  if (Hafas.Config.Switches.useMap) {
    Hafas.ps.sub('/app/events/resize', Hafas.bind(_me.Controller.Map.updateOffset, _me));
    Hafas.ps.sub('/app/events/resize', Hafas.bind(_me.Controller.Map.updateSize, _me));
  }

  // events controlling resultcontainer
  Hafas.ps.sub('/app/events/closeResults', Hafas.bind(_me.Controller.App.events.closeResults, _me));
};

HafasWebapp.prototype.subscriptions.common = function (_me) {
  // Common-Events -------------------------------------------------------------------------------------------------
  // getActualPosition
  Hafas.ps.sub('/common/getActualPosition', Hafas.bind(_me.Controller.Common.getActualPosition, _me));

  // Externe Links öffnen
  Hafas.ps.sub('/common/openExternalLink', Hafas.bind(_me.Controller.Common.openExternalLink, _me));

  Hafas.ps.sub('/common/observe/inputvalues', Hafas.bind(_me.Controller.Common.Observe.Inputs, _me));

  // Time & Date
  Hafas.ps.sub('/common/time/datepicker/open', Hafas.bind(_me.Controller.Common.Time.DatePicker.open, _me));
  Hafas.ps.sub('/common/time/datepicker/confirm', Hafas.bind(_me.Controller.Common.Time.DatePicker.confirm, _me));
  Hafas.ps.sub('/common/time/datepicker/cancel', Hafas.bind(_me.Controller.Common.Time.DatePicker.cancel, _me));
  Hafas.ps.sub('/common/time/datepicker/setData', Hafas.bind(_me.Controller.Common.Time.DatePicker.setData, _me));
  Hafas.ps.sub('/common/time/datepicker/onChangeOfNativeInput', Hafas.bind(_me.Controller.Common.Time.DatePicker.onChangeNativeInput, _me));
};


HafasWebapp.prototype.subscriptions.apis = function (_me) {
  // HTML5-API-Events --------------------------------------------------------------------------------------------------
  Hafas.ps.sub('/apis/geolocation/check', Hafas.bind(_me.Controller.APIs.Geolocation.check, _me));
};


HafasWebapp.prototype.subscriptions.exceptions = function (_me) {
  // Error-Events -------------------------------------------------------------------------------------------------
  Hafas.ps.sub('/exceptions/tq/getRoute', Hafas.bind(_me.Controller.Exceptions.TQ.getRoute, _me));
  Hafas.ps.sub('/exceptions/tq/drawHighlightedSection', Hafas.bind(_me.Controller.Exceptions.TQ.drawHighlightedSection, _me));
};

// TODO: Der Block gehört hier nicht her. Das sollte im TP stehen.
HafasWebapp.prototype.subscriptions.suggest = function (_me) {
// Suggest-Events --------------------------------------------------------------------------------------------------
  Hafas.ps.sub("/suggest/selectitem/From", Hafas.bind(function (loc, suggest, isValidation) {

    isValidation = !!isValidation;
    _me.Controller.TP.instance.setLocation("dep", loc);
    if (Hafas.Config.Switches.useFavorites && Hafas.Config.Favorites.addLocationOnSuggest) {
      var depLocProducts = Hafas.Modules.Suggest.getSuggestInstanceById('From').productRef;
      var depLocHistory = {
        name: loc.name,
        lid: loc.lid,
        prod: depLocProducts
      };
      _me.Controller.Favorites.instance.addLocation(depLocHistory, 'History');
    }
    Hafas.Modules.Validation.resetErrorField('From');
    if (!isValidation && Hafas('#To') && Hafas('#To').value === "") {
      Hafas('#To').focus();
    }
    Hafas.ps.pub("/tp/events/trigger/unified");
  }, _me));

  Hafas.ps.sub("/suggest/selectitem/HFS_Via0", Hafas.bind(function (loc) {
    // _me.Controller.TP.instance.setVia(loc,0);
    _me.Controller.TP.options.setRandomParameter("HFS_Via0", "value", loc);
    Hafas.Modules.Validation.resetErrorField('HFS_Via0');
    Hafas.ps.pub('/options/gui/toggle/via/options', [{id: "HFS_Via0", visibility: true}]);
  }, _me));

  Hafas.ps.sub("/suggest/selectitem/HFS_Via1", Hafas.bind(function (loc) {
    // _me.Controller.TP.instance.setVia({location: loc}, 1);
    _me.Controller.TP.options.setRandomParameter("HFS_Via1", "value", loc);
    Hafas.Modules.Validation.resetErrorField('HFS_Via1');
    Hafas.ps.pub('/options/gui/toggle/via/options', [{id: "HFS_Via1", visibility: true}]);
  }, _me));

  Hafas.ps.sub("/suggest/selectitem/HFS_SQDirection", Hafas.bind(function (loc) {
    _me.Controller.SQ.options.setRandomParameter("HFS_SQDirection", "value", loc);
    Hafas.ps.pub('/options/gui/toggle/delete', [{id: "HFS_SQDirection", visibility: true}]);
  }, _me));

  Hafas.ps.sub("/suggest/selectitem/To", Hafas.bind(function (loc) {
    _me.Controller.TP.instance.setLocation("arr", loc);
    if (Hafas.Config.Switches.useFavorites && Hafas.Config.Favorites.addLocationOnSuggest) {
      var arrLocProducts = Hafas.Modules.Suggest.getSuggestInstanceById('To').productRef;
      var arrLocHistory = {
        name: loc.name,
        lid: loc.lid,
        prod: arrLocProducts
      };
      _me.Controller.Favorites.instance.addLocation(arrLocHistory, 'History');
    }
    Hafas.Modules.Validation.resetErrorField('To');
    Hafas.ps.pub("/tp/events/trigger/unified");
  }, _me));
};


HafasWebapp.prototype.subscriptions.forms = function (_me) {
// Form-Events --------------------------------------------------------------------------------------------------
  Hafas.ps.sub('/forms/reset', Hafas.bind(_me.Controller.Forms.reset, _me));
};


HafasWebapp.prototype.subscriptions.favorites = function (_me) {
  // Favorite Controller Events
  // Location ausw�hlen
  Hafas.ps.sub('/favorites/setLocation', Hafas.bind(function (data) {
    var locationObj = _me.Controller.Favorites.instance.getLocationById(data.id, data.storage);
    var location = {
      name: locationObj.name,
      lid: locationObj.lid
    };

    // Tracking
    // Hier muss das Speicherobjekt der "location" untersucht werden, ob es sich um einen Favoriten oder nur um einen History-Eintrag
    // handelt.
    var lh = 0, lhLen = _me.Controller.Favorites.instance.data.locationsHistory.length;
    var _isLocHistory;
    // Wenn kein history-Eintrag vorhanden ist, kann es nur Favorit sein
    if (lhLen <= 0) {
      _isLocHistory = false;
    } else {
      // Prüfe die History-Einträge
      for (lh; lh < lhLen; lh++) {
        var _locEntry = _me.Controller.Favorites.instance.data.locationsHistory[lh];

        if (locationObj.lid == _locEntry.lid) {
          _isLocHistory = true;
        }
      }
    }


    if (data.type == "dep") {
      _me.Controller.TP.instance.setLocation(data.type, location);
      //Hafas.ps.pub('/tracking/event/favorites-locations-as-a', ['[' + _me.appContext + '] ' + location.lid]);
    } else if (data.type == "arr") {
      _me.Controller.TP.instance.setLocation(data.type, location);
      //Hafas.ps.pub('/tracking/event/favorites-locations-as-b', ['[' + _me.appContext + '] ' + location.lid]);
    } else if (data.type == "via") {
      _me.Controller.TP.instance.setVia(location);
      //Hafas.ps.pub('/tracking/event/favorites-locations-as-via', ['[' + _me.appContext + '] ' + location.lid]);
    } else if (data.type == "station") {
      // Disable search button, when a location has been selected from the favorites
      if (document.form_stationsearch.elements.submitSQForm) {
        Hafas.bind(_me.Controller.App.triggerLoadingImage, this)(document.form_stationsearch.elements.submitSQForm);
      }
      _me.Controller.SQ.instance.setLocation(location);
      Hafas.bind(_me.Controller.SQ.resetResults, _me)();
      _me.Controller.SQ.instance.search(Hafas.bind(_me.Controller.SQ.showResult, _me));
      //Hafas.ps.pub('/tracking/event/favorites-locations-as-input', ['[' + _me.appContext + '] ' + location.lid]);
    } else if (data.type == 'reachability') {
      _me.Controller.Reachability.instance.setLocation(location);
      Hafas.ps.pub('/tracking/event/favorites-locations-as-input', ['[' + _me.appContext + '] ' + location.lid]);
    } else if (data.type == 'timetable') {
      if (location.name) {
        Hafas('#TimetableStopInput').value = location.name;
      }
      Hafas.bind(_me.Controller.Timetable.processStopInput, _me)({loc: location});
    }
    if (_isLocHistory !== true) {
      Hafas.ps.pub('/tracking/event/favorite-location-selected', [{typ: 'event', key: 'favorite-location-selected'}]);
      Hafas.ps.pub('/tracking/event/locationsearch-favorite-selected', [{
        typ: 'event',
        key: 'locationsearch-favorite-selected'
      }]);
    } else {
      Hafas.ps.pub('/tracking/event/history-location-selected', [{typ: 'event', key: 'history-location-selected'}]);
    }
  }, this));

  // Linie ausw�hlen
  Hafas.ps.sub('/favorites/setLine', Hafas.bind(function (data) {
    if (data.context == 'linesearch') {
      if (data.hasOwnProperty('storage') && (data.storage === "history")) {
        Hafas.ps.pub('/linesearch/selectLineFromHist', [data.lineId]);
      } else {
        Hafas.ps.pub('/linesearch/selectLineFromFav', [data.lineId]);
      }
    } else if (data.context == 'timetable') {
      var dataStorage = "lines";
      if (data.storage === "history") {
        dataStorage += "History";
      }
      var line = _me.Controller.Favorites.instance.getLineById(data.lineId, dataStorage);
      Hafas.bind(_me.Controller.Timetable.processLineInput, _me)({line: line});
    }
  }, this));

  // Verbindung ausw�hlen
  Hafas.ps.sub('/favorites/setConnection', Hafas.bind(function (data) {
    // Falls vorher Optionen gesetzt waren, müssen diese zurückgesetzt werden
    Hafas.ps.pub('/options/reset');
    _me.Controller.TP.markerIsLoaded = false;
    var connection = _me.Controller.Favorites.instance.getConnectionById(data.id, data.storage);
    for (var k in connection) {
      if (typeof connection[k].lid != "undefined") {
        var currentConnection = {};
        currentConnection['lid'] = connection[k].lid;
        currentConnection['name'] = connection[k].name;
        _me.Controller.TP.instance.setLocation(k, currentConnection);
      }
      if (typeof connection[k].mod != "undefined") {
        _me.Controller.TP.options.injectModifiedModel(connection[k].mod);
      }
    }
    var form = Hafas.Core.newType("hafasValidation", {
      form: document.formTripsearch   // TO DO Formular�bergabe
    });
    if (form.valid) {

      // Disable search button, when a location has been selected from the favorites
      Hafas.bind(_me.Controller.App.triggerLoadingImage, this)(document.formTripsearch.elements.submitTPForm);

      // close all additional resultcontainer
      Hafas.ps.pub('/GUI/results/additional/hideAll');

      // hide ResultOverview + Detail
      Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
      Hafas.ps.pub('/GUI/results/details/hide', [{}]);
      _me.Controller.TP.visibleClusterGroup = _me.Controller.TP.getInitialGroup();
      _me.Controller.TP.instance.search({
        ptCallback: Hafas.bind(_me.Controller.TP.showResultOverview, _me),
        ivCallback: Hafas.bind(_me.Controller.TP.showIVResultOverview, _me)
      });
    }

    // Tracking
    // Hier muss das Speicherobjekt untersucht werden, ob es sich um einen Favoriten oder nur um einen History-Eintrag
    // handelt. Klick auf dieses Element wird auf 2 unterschiedliche Arten getrackt
    // Muss für die Ortssuche auch getan werden
    var ch = 0, chLen = _me.Controller.Favorites.instance.data.connectionsHistory.length;
    var _isHistory;
    // Wenn kein history-Eintrag vorhanden ist, kann es nur Favorit sein
    if (chLen <= 0) {
      _isHistory = false;
    } else {
      // Prüfe die History-Einträge
      for (ch; ch < chLen; ch++) {
        var _entry = _me.Controller.Favorites.instance.data.connectionsHistory[ch];

        if (_entry.opt.hash == connection.opt.hash) {
          _isHistory = true;
        }
      }
    }

    if (_isHistory === true) {
      Hafas.ps.pub('/tracking/event/use-history', [{typ: 'event', key: 'use-history'}]);
      Hafas.ps.pub('/tracking/event/history-connection-selected', [{typ: 'event', key: 'history-connection-selected'}]);
    } else {
      Hafas.ps.pub('/tracking/event/use-favorite', [{typ: 'event', key: 'use-favorite'}]);
      Hafas.ps.pub('/tracking/event/favorite-connection-selected', [{
        typ: 'event',
        key: 'favorite-connection-selected'
      }]);
    }
  }, _me));

  /**
   * Accessibility Helper for favorites/history list changes
   *
   * @param {string} storage Either 'favorites' or 'history'
   * @param {object} params Containing 'arr' and 'dep' or 'lid' in order to check for the correct station name to announce
   * @param {boolean} added Favorite has been added or removed from a list?
   */
  function _announceFavoriteChange(storage, params, added) {
    var i18nKey;
    var i18nProps;

    if (params.dep && params.arr) {
      switch (storage) {
        case 'favorites':
          i18nKey = added ? 'Favorites.t_N_addedConnectionToFavorites' : 'Favorites.t_N_removedConnectionFromFavorites';
          break;
        case 'history':
          // no check for 'added', because this case does not exist
          i18nKey = 'Favorites.t_N_removedConnectionFromHistory';
          break;
        default:
          return;
      }
      i18nProps = {
        from: Hafas.Util.location.createLocationFromLid(params.dep.lid).name,
        to: Hafas.Util.location.createLocationFromLid(params.arr.lid).name
      };
      if (params.opt && params.opt.txt) {
        i18nProps.options = params.opt.txt;
      }
    } else {
      switch (storage) {
        case 'favorites':
          i18nKey = added ? 'Favorites.t_N_itemAddedToFavorites' : 'Favorites.t_N_itemRemovedFromFavorites';
          break;
        case 'history':
          // no check for 'added', because this case does not exist
          i18nKey = 'Favorites.t_N_itemRemovedFromHistory';
          break;
        default:
          return;
      }

      i18nProps = {item: ''};

      // locations
      if (params.lid)
        i18nProps.item = Hafas.Util.location.createLocationFromLid(params.lid).name;
      // lines
      else if (params.lineId)
        i18nProps.item = params.prodResolved.name;
    }

    Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get(i18nKey, i18nProps));
  }

  /* Location vom Verlauf zu Favoriten verschieben */
  Hafas.ps.sub('/favorites/addLocToFav', Hafas.bind(function (params) {
    if (typeof params.id === 'number') {
      _me.Controller.Favorites.instance.moveLocationFromHistoryToFav(params.id);
    } else {
      _me.Controller.Favorites.instance.addLocationToFav(params);
    }

    _announceFavoriteChange('favorites', params, true);

    // Tracking
    Hafas.ps.pub('/tracking/event/save-favorite', [{typ: 'event', key: 'save-favorite'}]);
    Hafas.ps.pub('/tracking/event/favorite-location-marked', [{typ: 'event', key: 'favorite-location-marked'}]);
  }, _me));

  /* Favorit entfernen und automatisch dem Verlauf beif�gen */
  Hafas.ps.sub('/favorites/removeFavToHistory', Hafas.bind(function (params) {
    if (typeof params.id === 'number') {
      _me.Controller.Favorites.instance.removeLocationFav(params.id);
    } else {
      _me.Controller.Favorites.instance.removeLocationFav(params);
    }

    _announceFavoriteChange('favorites', params, false);

    // Tracking
    Hafas.ps.pub('/tracking/event/delete-favorite', [{typ: 'event', key: 'delete-favorite'}]);
    Hafas.ps.pub('/tracking/event/favorite-location-unmarked', [{typ: 'event', key: 'favorite-location-unmarked'}]);
  }, _me));


  /* Verbindung vom Verlauf zu Favoriten verschieben */
  Hafas.ps.sub('/favorites/addConnToFav', Hafas.bind(function (params) {
    var _entry = _me.Controller.Favorites.instance.getConnectionByHash(params, 'History');
    _me.Controller.Favorites.instance.addConnectionFromHistory(params);

    _announceFavoriteChange('favorites', _entry, true);

    // Tracking
    Hafas.ps.pub('/tracking/event/save-favorite', [{typ: 'event', key: 'save-favorite'}]);
    Hafas.ps.pub('/tracking/event/favorite-connection-marked', [{typ: 'event', key: 'favorite-connection-marked'}]);
  }, _me));

  /* Connection Favorit entfernen und automatisch dem Verlauf beif�gen */
  Hafas.ps.sub('/favorites/removeConnToHistory', Hafas.bind(function (params) {
    var _entry = _me.Controller.Favorites.instance.getConnectionByHash(params);
    _me.Controller.Favorites.instance.removeConnectionFav(params);

    _announceFavoriteChange('favorites', _entry, false);

    Hafas.ps.pub('/tracking/event/delete-favorite', [{typ: 'event', key: 'delete-favorite'}]);
    Hafas.ps.pub('/tracking/event/favorite-connection-unmarked', [{typ: 'event', key: 'favorite-connection-unmarked'}]);
  }, _me));

  Hafas.ps.sub('/favorites/addLineToFav', Hafas.bind(function (line) {
    _me.Controller.Favorites.instance.addLine(line);

    _announceFavoriteChange('favorites', line, true);
  }));

  Hafas.ps.sub('/favorites/addLineToHistory', Hafas.bind(function (line) {
    _me.Controller.Favorites.instance.addLineToHistory(line);
  }));

  Hafas.ps.sub('/favorites/removeLine', Hafas.bind(function (lineId) {
    var removedLine = _me.Controller.Favorites.instance.removeLine(lineId);

    _announceFavoriteChange('favorites', removedLine, false);
  }, _me));

  Hafas.ps.sub('/favorites/addLineFromHist', Hafas.bind(function (lineId) {
    var addedLine = _me.Controller.Favorites.instance.addLineFromHist(lineId);

    _announceFavoriteChange('favorites', addedLine, true);
  }, _me));

  /* Update der Oberfl�che */
  Hafas.ps.sub('/favorites/update', Hafas.bind(function () {
    // TODO: FavoriteController! (Ja, sollte mal jemand machen)
    var tempModel = null;
    var tempTpl, tempTarget = "";
    if (typeof Hafas.Config.showFavoriteBox == 'undefined' || Hafas.Config.showFavoriteBox == true) {
      if (_me.Controller.Favorites.main.appContext == "SQ") {
        if (Hafas.Config.SQ.allType) {
          tempModel = _me.Controller.Favorites.instance.getData();
        } else {
          tempModel = _me.Controller.Favorites.instance.getData(1);
        }
        tempTpl = "SQ_AtomTplFieldFav_Stations";
        tempTarget = "HFS_FavLocationsSQ";
        // add the length of favorite locations/ locationsHistory together
        tempModel.entryLengthLoc = tempModel.locations.length + tempModel.locationsHistory.length;
      } else if (_me.Controller.Favorites.main.appContext == "TP") {
        tempModel = _me.Controller.Favorites.instance.getData();
        tempTpl = "TP_AtomTplFieldFav_Locations";
        tempTarget = "HFS_FavLocationsTP";
        // add the length of favorite locations/ locationsHistory together
        tempModel.entryLengthLoc = tempModel.locations.length + tempModel.locationsHistory.length;
        tempModel.entryLengthCon = tempModel.connections.length + tempModel.connectionsHistory.length;
        tempModel.className = 'hfs_favLocationsTab';
        var conModel = Hafas.Core.clone(_me.Controller.Favorites.instance.getData());
        conModel.className = 'hfs_favConnectionsTab';
        Hafas.Modules.Render.render({
          target: "HFS_FavConnectionsTP",
          template: "TP_AtomTplFieldFav_Connections",
          model: tempModel
        });
      } else if (_me.Controller.Favorites.main.appContext == "LineSearch") {
        tempModel = _me.Controller.Favorites.instance.getData();
        tempModel.entryLengthLines = tempModel.lines.length + tempModel.linesHistory.length;
        tempModel.context = "linesearch";
        tempTpl = "LineSearch_TplFavorites";
        tempTarget = "HFS_LineFavorites";
      } else if (_me.Controller.Favorites.main.appContext == "Reachability") {
        tempModel = _me.Controller.Favorites.instance.getData();
        tempTpl = "Reachability_AtomTplFieldFav_Stations";
        tempTarget = 'HFS_FavLocationsReachability';
        tempModel.entryLengthLoc = tempModel.locations.length + tempModel.locationsHistory.length;
      } else if (_me.Controller.Favorites.main.appContext == "Timetable") {
        var selectedInput = Hafas.bind(_me.Controller.Timetable.getSelectedInput, _me)();
        if (selectedInput === "stop") {
          tempModel = _me.Controller.Favorites.instance.getData(1);
          tempModel.type = "timetable";
          tempTpl = "SQ_AtomTplFieldFav_Stations";
          tempTarget = "HFS_FavLocationsTimetable";
          // add the length of favorite locations/ locationsHistory together
          tempModel.entryLengthLoc = tempModel.locations.length + tempModel.locationsHistory.length;
        } else if (selectedInput === "line") {
          tempModel = Hafas.bind(_me.Controller.Timetable.processFavoritesData, _me)(_me.Controller.Favorites.instance.getData());
          tempModel.context = "timetable";
          tempModel.entryLengthLines = tempModel.lines.length + tempModel.linesHistory.length;
          tempTpl = "LineSearch_TplFavorites";
          tempTarget = "HFS_TimetableFavorites";
        }
      }

      if (Hafas("#" + tempTarget) != null) {
        Hafas.Modules.Render.render({
          target: tempTarget,
          template: tempTpl,
          model: tempModel
        });
      }
    }

    // TODO: FavoriteController!
    var favIcons = Hafas('[data-render="favIcon"]', true);
    favIcons.forEach(function (favIcon) {
      var lid = favIcon.getAttribute('data-lid');
      if (lid) {
        var name = favIcon.getAttribute('data-name');
        var location = {lid: lid, name: name};
        var focus = false;
        if (document.activeElement === favIcon.firstElementChild) {
          focus = true;
        }
        var favModel = Hafas.Modules.Atoms.createAtomModel('common.favorites.locations.favButton', new Hafas.Modules.Render.RenderModel(location));

        favIcon.firstElementChild.parentNode.removeChild(favIcon.firstElementChild);

        Hafas.Modules.Render.render({
          target: favIcon,
          template: 'Common_AtomTplButton',
          model: favModel
        }, function () {
          if (focus) {
            favIcon.firstElementChild.focus();
          }
        });

      }
    });

    var contextMenuConfig = {
      trigger: ['clickRight'],
      stickTo: 'bottom|right',
      useMousePosition: true,
      renderParentElement: document.body,
      zIndex: 20000,
      content: [
        {
          text: Hafas.Modules.i18n.get('common.label.t_N_delete'),
          event: function (contextMenu) {
            var elem = contextMenu.parent;
            var opts = {
              storage: elem.parentElement.dataset.storage,
            };

            for (var entry in elem.dataset) {
              opts[entry] = elem.dataset[entry];
            }

            Hafas.ps.pub('/favorites/deleteEntry', [opts]);

            // Für das Tracking kann opts.storage ausgelesen und verwendet werden.
            // Hier sind wieder alte und neue trackingbezeichner bzw LEGACY/BASIS/PREMIUM vermischt!
            switch (opts.storage) {
              case 'locations':
                // delete favorite location
                Hafas.ps.pub('/tracking/event/delete-favorite', [{typ: 'event', key: 'delete-favorite'}]);
                break;
              case 'locationsHistory':
                // delete history location
                Hafas.ps.pub('/tracking/event/history-location-deleted', [{
                  typ: 'event',
                  key: 'history-location-deleted'
                }]);
                break;
              case 'connections':
                // delete favorite connection
                Hafas.ps.pub('/tracking/event/delete-favorite', [{typ: 'event', key: 'delete-favorite'}]);
                break;
              case 'connectionsHistory':
                // delete history connection
                Hafas.ps.pub('/tracking/event/history-connection-deleted', [{
                  typ: 'event',
                  key: 'history-connection-deleted'
                }]);
                break;
            }
          }
        }
      ]
    };
    Hafas('.lyr_favoriteRow', true).forEach(function (elem) {
      Hafas.Core.newType('HafasContextMenu', contextMenuConfig).addTo(elem);
    });

    Hafas.ps.pub('/GUI/common/fixedElements/setHeights', [{me: this}]);
  }, _me));

  Hafas.ps.sub('/favorites/clearHistoryOverlay', Hafas.bind(function (favCat) {
    var me = this;
    var model = {
      msg: Hafas.Modules.i18n.get("Favorites.t_N_delete" + favCat + "OverlayText"),
      button_text_ok: Hafas.Modules.i18n.get("Favorites.t_N_delete"),
      button_text_cancel: Hafas.Modules.i18n.get("common.label.t_N_cancel"),
      event_ok: "Hafas.ps.pub('/favorites/clear" + favCat + "History'); ",
      event_cancel: "Hafas.ps.pub('/common/cancelOverlay'); "
    };
    Hafas.Modules.Render.render({
      file: 'common.overlay.html',
      template: 'Overlay_TplDeleteFavorites',
      model: model
    },
    function (html) {
      overlay = Hafas.Core.newType("HafasOverlay", {
        app: me,
        title: Hafas.Modules.i18n.get("Favorites.t_N_delete" + favCat + "OverlayHeader"),
        outputHTML: html,
        cssClass: 'hfs_favoritesOverlay'
      });
    }
    );
  }, _me));

  /* Location-History l�schen */
  Hafas.ps.sub('/favorites/clearLocationHistory', Hafas.bind(function () {
    Hafas.ps.pub('/common/cancelOverlay');
    _me.Controller.Favorites.instance.clearLocationHistory();
  }, _me));

  /* Connection-History l�schen */
  Hafas.ps.sub('/favorites/clearConnectionHistory', Hafas.bind(function () {
    Hafas.ps.pub('/common/cancelOverlay');
    _me.Controller.Favorites.instance.clearConnectionHistory();
  }, _me));

  Hafas.ps.sub('/common/cancelOverlay', Hafas.bind(function () {
    if (typeof overlay != "undefined") {
      overlay.close();
    }
  }, _me));

  Hafas.ps.sub('/common/hideOverlay', Hafas.bind(function (overlayId) {
    Hafas('#HFS_WebApp').style.display = "";
    Hafas("#HFS_AriaReload").innerHTML = ".";
    var span = document.createElement("span");
    span.innerHTML = ".";
    Hafas('#HFS_WebApp').appendChild(span);
    var overlay = Hafas.Modules.Components.getOverlayById(overlayId),
    webAppClass = Hafas('#HFS_WebApp', false);
    if (overlay) {

      if (webAppClass.classList.contains('layout-small') || webAppClass.classList.contains('layout-mid')) {
        Hafas('#HFS_Overlay' + overlayId).addClassName('js_closeOverLay');
        setTimeout(function () {
          if(overlayId === 'ReturnTicketOverlay'){
            overlay.closeIR();
          }else{
            overlay.close();
          }

        }, 300);
      } else {
        if(overlayId === 'ReturnTicketOverlay'){
          overlay.closeIR();
        }else{
          overlay.close();
        }
      }
    }

  }, _me));

  /* Occurs when right-click menu is used in order to remove favorite/history entry */
  Hafas.ps.sub('/favorites/deleteEntry', Hafas.bind(function (opts) {
    var removedEntry = _me.Controller.Favorites.instance.clearFavEntry(opts);
    var storage;

    switch (opts.storage) {
      case 'locations':
      case 'connections':
      case 'lines':
        storage = 'favorites';
        break;
      case 'locationsHistory':
      case 'connectionsHistory':
      case 'linesHistory':
        storage = 'history';
        break;
      default:
        return;
    }

    _announceFavoriteChange(storage, removedEntry, false);
  }, _me));

  Hafas.ps.sub('/IFrameAPI/CloseIFrameFullscreen', Hafas.bind(function () {
    if (Hafas.Modules.IFrameApi)
      Hafas.Modules.IFrameApi.sendCloseIframeFullscreen();
  }));


};
